import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a0704cf6b5c55c2a6c81f35bc0aceaabeb from "./generated-0102f312-cac7-4e4f-a128-c33df98061c9.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/bookmaker-settings"){
            
                    await direct(a0704cf6b5c55c2a6c81f35bc0aceaabeb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */